import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.png";
import projImg8 from "../assets/img/project-img8.png";
import projImg9 from "../assets/img/project-img9.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title:"Konsultacje",
      description: "Pierwsza wizyta (1,5 godziny) obejmuje szczegółowy wywiad i ustalenie celów terapii. Następnie rozpoczynamy fizjoterapię i omawiam proste ćwiczenia do codziennego wykonywania.",
      imgUrl: projImg1,
    },
    {
      title:"Terapia uroginekologiczna",
      description: "Każda kolejna wizyta to analiza postępów i kontynuacja pracy nad poprawą funkcji dna miednicy.",
      imgUrl: projImg2,
    },
    {
      title:"Przygotowanie do porodu",
      description: "Polega na wzmacnianiu mięśni dna miednicy, nauce technik oddechowych i poprawie świadomości ciała, aby wspomóc poród i zminimalizować ryzyko powikłań.",
      imgUrl: projImg3,
    },
    {
      title:"Ćwiczenia po porodzie",
      description: "Wzmacnianie mięśni dna miednicy, stabilizacja i poprawa elastyczności tkanek, aby przywrócić pełną sprawność i zapobiec dysfunkcjom.",
      imgUrl: projImg4,
    },
    {
      title:"Terapia blizn",      
      description: "Leczenie blizn po cesarce, nacięciach czy pęknięciach krocza za pomocą terapii manualnej, kinesiotapingu i terapii TECAR.",
      imgUrl: projImg5,
    },
    {
      title:"Kinesiotaping",
      description: "Aplikacja specjalnych elastycznych taśm, które wspierają mięśnie i stawy, redukują ból, poprawiają krążenie oraz wspomagają regenerację tkanek bez ograniczania ruchu.",
      imgUrl: projImg6,
    },
    {
      title:"Terapia manualna", 
      description: "Delikatne techniki manualne stosowane w celu poprawy mobilności tkanek, zmniejszenia napięć i bólu w obrębie miednicy oraz wspomagania prawidłowej funkcji mięśni dna miednicy i narządów wewnętrznych.",
      imgUrl: projImg7,
    },
    {
      title:"Terapia TECAR", 
      description: "Zaawansowana metoda wykorzystująca fale radiowe do stymulacji naturalnych procesów regeneracyjnych, poprawy krążenia, redukcji bólu i przyspieszenia gojenia tkanek, szczególnie skuteczna w terapii blizn oraz dysfunkcji mięśni dna miednicy.",
      imgUrl: projImg8,
    },
    {
      title:"Pilates", 
      description: "Ćwiczenia wzmacniające i uelastyczniające, skupiające się na mięśniach dna miednicy, stabilizacji kręgosłupa oraz poprawie postawy.",
      imgUrl: projImg9,
    },
  ];

  return (
    
    <section className="project" id="projects">
            <div class="section-divider"></div>
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              /*<div className={isVisible ? "animate__animated animate__fadeIn": ""}>*/
              <div>
                <h2>Usługi</h2>
                <p>Dzięki odpowiednio dobranym metodom, fizjoterapia uroginekologiczna może znacząco poprawić komfort życia, przywracając sprawność mięśni dna miednicy i eliminując dolegliwości związane z układem moczowo-płciowym.<br />Poniżej znajdziesz listę oferowanych usług:</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    {/*<Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>*/}
                  </Nav>
                  {/*className={isVisible ? "animate__animated animate__slideInUp" : ""}*/} 
                  <Tab.Content id="slideInUp" >
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
